export default class TooManyRequestsError extends Error {}
